import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Link from '../../../elements/Link';
import Text from '../../../elements/Text';

interface Props {
  showPhoneNumberLabel?: boolean;
  showPhoneNumber?: boolean;
  /**
   * Wether the item is interactive dialing the corresponding number on tap
   */
  isCallable?: boolean;
  phoneNumberLabelKey?: string;
  phoneNumber?: string;
  phoneNumberLabelStyles?: StyledProps;
  phoneNumberStyles?: StyledProps;
}

function TelephoneNumber({
  showPhoneNumberLabel = true,
  showPhoneNumber = true,
  phoneNumberLabelKey = 'cmp-bus-directory-map-telephone-main',
  phoneNumber = '',
  phoneNumberStyles = {},
  isCallable = false,
  phoneNumberLabelStyles,
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);

  return (
    <Box display="flex" alignItems="start" className="station-item-telephone-number" {...props}>
      {showPhoneNumberLabel && (
        <Text marginRight="1" {...phoneNumberLabelStyles}>
          {translate(phoneNumberLabelKey, 'Telephone numbers')}
        </Text>
      )}
      {showPhoneNumber &&
        (isCallable ? (
          <Link href={`tel:${phoneNumber}`} {...phoneNumberStyles}>
            {phoneNumber}
          </Link>
        ) : (
          <Text fontWeight="bold" {...phoneNumberStyles}>
            {phoneNumber}
          </Text>
        ))}
    </Box>
  );
}

TelephoneNumber.componentName = 'TelephoneNumber';

export default TelephoneNumber;
